import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {PageResponse} from "../models/page-response";
import {environment} from "../../environments/environment";
import {Project} from "../models/project";
import {Sort} from "../models/sort";
import {SortHelper} from "../utils/sort-helper";
import {ProjectLocation} from "../models/project-location";

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private httpClient: HttpClient) { }

  list(page: number, sort?: Sort, filters: HttpParams = new HttpParams()) {
    let params = filters.set('page', page.toString());

    if (sort) {
      params = params.set('sort', SortHelper.convertSortToString(sort));
    }

    return this.httpClient.get<PageResponse<Project>>(`${environment.api}/api/v1/projects`, {
      params,
    });
  }

  locations() {
    return this.httpClient.get<ProjectLocation[]>(`${environment.api}/api/v1/projects/locations`);
  }

  detail(id: number | string) {
    return this.httpClient.get<Project>(`${environment.api}/api/v1/projects/${id}`);
  }

  delete(project: Project) {
    return this.httpClient.delete(`${environment.api}/api/v1/projects/${project.id}`);
  }

  create(project: Project) {
    return this.httpClient.post<Project>(`${environment.api}/api/v1/projects`, project);
  }

  update(project: Project) {
    return this.httpClient.put<Project>(`${environment.api}/api/v1/projects/${project.id}`, project);
  }

  externalIdExists(externalId: string) {
    return this.httpClient.get<boolean>(`${environment.api}/api/v1/projects/external-id-exists`, {
      params: new HttpParams().set('externalId', externalId),
    });
  }
}
